import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const StickyCTA = ({ product, quoteTo }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const nearBottom = y + window.innerHeight > document.documentElement.scrollHeight - 900;
      setShow(y > 520 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta"
      aria-hidden={!show}
      className={`md:hidden fixed inset-x-3 bottom-3 z-40 transition-all duration-400 ${
        show ? "translate-y-0 opacity-100" : "translate-y-24 opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex items-center justify-between gap-3 rounded-full bg-[#0B132B]/90 backdrop-blur-xl ring-1 ring-white/15 shadow-2xl shadow-[#0B132B]/40 pl-5 pr-2 py-2">
        <div className="min-w-0">
          <p className="text-[11px] tracking-[0.18em] uppercase text-[#4CC3F0] font-bold leading-none">Free quote</p>
          <p className="text-sm font-semibold text-white truncate mt-0.5">{product.name}</p>
        </div>
        <Link
          to={quoteTo}
          data-testid="sticky-cta-button"
          className="inline-flex items-center gap-1.5 rounded-full bg-[#29ABE2] text-white font-semibold text-sm px-4 py-2.5 shrink-0 active:scale-95 transition-transform"
        >
          Get started <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
};
